import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import { businessData } from './seoConfig';

export const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => setIsOpen(!isOpen);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <header className="fixed w-full top-0 z-50 bg-[#FAF8F4]/95 backdrop-blur-sm border-b border-[#E8DDD8]">
      <nav className="max-w-6xl mx-auto px-6 md:px-20">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0">
            <div className="font-serif text-2xl text-[#0B0B0B] tracking-tight">
              GiGi
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`text-sm tracking-widest uppercase transition-colors ${
                  location.pathname === link.path
                    ? 'text-[#0B0B0B]'
                    : 'text-[#6B6970] hover:text-[#0B0B0B]'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/contact"
              className="px-6 py-2 bg-[#0B0B0B] text-white rounded-2xl text-sm font-medium hover:shadow-md transition-all"
            >
              Book Now
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="md:hidden p-2 rounded-lg hover:bg-[#E8DDD8] transition-colors"
            aria-label="Toggle menu"
          >
            {isOpen ? (
              <FiX size={24} className="text-[#0B0B0B]" />
            ) : (
              <FiMenu size={24} className="text-[#0B0B0B]" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden pb-4 space-y-2 border-t border-[#E8DDD8] mt-2 pt-4">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`block px-4 py-3 rounded-lg transition-colors text-sm tracking-widest uppercase ${
                  location.pathname === link.path
                    ? 'bg-[#E8DDD8] text-[#0B0B0B]'
                    : 'text-[#6B6970] hover:bg-[#E8DDD8] hover:text-[#0B0B0B]'
                }`}
                onClick={() => setIsOpen(false)}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/contact"
              className="block px-4 py-3 bg-[#0B0B0B] text-white rounded-lg text-center font-medium text-sm hover:shadow-lg transition-all"
            >
              Book Appointment
            </Link>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
